// extracted by mini-css-extract-plugin
export var ContentContainer = "section-module--ContentContainer--g9NaG";
export var container = "section-module--container--P+4oJ";
export var fade = "section-module--fade--05YOG";
export var headText = "section-module--headText--Oi7Mj";
export var header = "section-module--header--FONoQ";
export var headerIMG = "section-module--headerIMG--orW5I";
export var image = "section-module--image--Xcf4x";
export var startFade = "section-module--startFade--ojMHN";